export const FREE_NFT_EVENT_LIST_REQUEST = 'FREE_NFT_EVENT_LIST_REQUEST';

export const FREE_NFT_EVENT_LIST = 'FREE_NFT_EVENT_LIST';

export const FREE_NFT_EVENT_RESPONSE_MESSAGE = 'FREE_NFT_EVENT_RESPONSE_MESSAGE';

export const FREE_NFT_EVENT_CREATE_REQUEST = 'FREE_NFT_EVENT_CREATE_REQUEST';

export const FREE_NFT_EVENT_INFO_DETAILS_REQUEST = 'FREE_NFT_EVENT_INFO_DETAILS_REQUEST';

export const FREE_NFT_EVENT_INFO_DETAILS = 'FREE_NFT_EVENT_INFO_DETAILS';

export const FREE_NFT_EVENT_INFO_UPDATE_REQUEST = 'FREE_NFT_EVENT_INFO_UPDATE_REQUEST';

export const FREE_NFT_EVENT_INFO_DELETE_REQUEST = 'FREE_NFT_EVENT_INFO_DELETE_REQUEST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_FREE_NFT_EVENT_PAGINATION = 'SET_FREE_NFT_EVENT_PAGINATION';

export const FREE_NFT_EVENT_PAGE_RESET = 'FREE_NFT_EVENT_PAGE_RESET';
